import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSearch } from '../context/SearchContext';
import { useTheme } from '../context/ThemeContext';
import logo from '../asset/Logo-KLYNN1.png';
import { useEffect, useState } from 'react';
import axios from 'axios';
import '../asset/css/header.css';
import API_URL from '../config';

const API = API_URL;

const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

export default function Header() {
    const { user, logout } = useAuth();
    const { searchQuery, setSearchQuery } = useSearch();
    const { theme, toggleTheme } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    const [genders, setGenders] = useState([]);
    const [categoriesByGender, setCategoriesByGender] = useState({});

    useEffect(() => {
        axios.get(`${API}/api/products/genders`)
            .then(async res => {
                const genderList = res.data;
                setGenders(genderList);
                const catMap = {};
                await Promise.all(genderList.map(async g => {
                    const catRes = await axios.get(`${API}/api/products/categories`, { params: { gender: g } });
                    catMap[g] = catRes.data;
                }));
                setCategoriesByGender(catMap);
            })
            .catch(err => console.error('Erreur fetch header:', err));
    }, []);

    return (
        <header className="header">
            <div className="header-top">
                <div className="header-logo">
                    <Link to="/" className="logo-link">
                        <img src={logo} alt="Logo de la boutique" className="logo-img" loading="lazy" />
                    </Link>
                </div>

                <input
                    type="text"
                    placeholder="🔍 Rechercher ..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="search-input"
                />

                <nav className="nav-links">
                    {user ? (
                        <>
                            <Link to="/cart" className="nav-link">Panier</Link>
                            {user.isAdmin && <Link to="/admin" className="nav-link">Admin</Link>}
                            <Link to="/profile" className="nav-link">{user.username}</Link>
                            <button onClick={() => { navigate("/"); logout(); }} className="logout-btn">
                                Déconnexion
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="nav-link">Connexion</Link>
                            <Link to="/register" className="nav-link">Inscription</Link>
                        </>
                    )}
                    <button
                        onClick={toggleTheme}
                        className="theme-toggle-btn"
                        aria-label="Basculer le mode sombre/clair"
                        title={theme === 'light' ? 'Passer en mode sombre' : 'Passer en mode clair'}
                    >
                        {theme === 'light' ? '🌙' : '☀️'}
                    </button>
                </nav>
            </div>

            {location.pathname !== '/' &&
                <div className="nav-dropdown">
                    <div className='menu'>
                        <Link to='/sales' className="link">Promotions</Link>
                    </div>
                    {genders.map(gender => (
                        <div key={gender} className="menu">
                            <Link to={`/${gender}`} className="link">{capitalize(gender)}</Link>
                            <div className="dropdown-cat">
                                {(categoriesByGender[gender] || []).map(cat => (
                                    <div key={cat} className="menuItem">
                                        <Link to={`/${gender}/${cat}`} className="link">{cat}</Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            }
        </header>
    );
}
